import React, { useContext, useEffect, useState } from "react";
import { getData } from "../../lib/utils";
import { Context } from "../contexts/AppContext";
import Analytics from "../PropertyList/Analytics";

function PhotoAnalytics() {
  const [selectedUser, setSelectedUser] = useState(null);
    const { value, progress } = useContext(Context);
  const [appState, setAppState] = value;
  
  console.log("PPPPPPPPPPPPPPPP ",appState)

  const data = [
    {
      id: 1,
      selfie:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43b?w=150",
      name: "Ashwani Kumar",
      email: "ashwani@gmail.com",
      phone: "9876543210",
      downloadCount: 12,
      likedPhotos: [
        "Bride Entry.jpg",
        "Family Photo.jpg",
        "Couple Shoot.jpg",
        "Stage Entry.jpg",
        "Wedding Moments.jpg",
      ],
      lastActivity: "20 Jun 2026",
    },
  ];

 const [faceLogs, setFaceLogs] = useState([]);

useEffect(() => {

  const fetchLogs = async () => {
    try {
      const json = await getData(
        `guest-log/get-face-search-log/${appState?.currentGalleryData?._id}`
      );

      if (json?.success) {
        console.log("JJJJJJJJJJJJ ",json.data)
        setFaceLogs(json.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (appState?.currentGalleryData?._id) {
    fetchLogs();
  }

}, [appState?.currentGalleryData?._id]);

  return (
   <div className="p-4">
  <h2 className="text-2xl font-bold mb-4">
    Photo Analytics
  </h2>

  <div className="overflow-x-auto rounded-xl shadow border">
    <table className="min-w-[800px] w-full table-auto bg-white">
      <thead>
        <tr className="bg-gray-100 border-b">
          <th className="p-3 text-center whitespace-nowrap  w-[300px]">
            Name
          </th>
          <th className="p-3 text-center whitespace-nowrap  w-[400px]">
            Email
          </th>
          <th className="p-3 text-center whitespace-nowrap">
            Phone
          </th>
          <th className="p-3 text-center whitespace-nowrap">
            Downloads
          </th>
          <th className="p-3 text-center whitespace-nowrap">
            likedPhotos
          </th>
          <th className="p-3 text-center whitespace-nowrap">
            Matched Photos
          </th>
        </tr>
      </thead>

      <tbody>
        {faceLogs.map((user) => (
          <tr
            key={user._id}
            className="border-b hover:bg-gray-50"
          >
            <td className="p-3 whitespace-nowrap  w-[300px]">
              {user.guestName}
            </td>

            <td className="p-3 whitespace-nowrap w-[400px]">
              {user.guestEmail}
            </td>

            <td className="p-3 whitespace-nowrap">
              {user.guestMobile}
            </td>

            <td className="p-3 text-center">
              {user.downloads?.length || 0}
            </td>

            <td className="p-3 text-center">
              <button
                onClick={() => setSelectedUser(user)}
                className="bg-blue-100 text-blue-700 px-3 py-1 rounded-lg"
              >
                {user.likedPhotos?.length || 0}
              </button>
            </td>

            <td className="p-3 text-center">
              {user.matchedPhotoCount || 0}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
      </div>
      
      {selectedUser && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-lg rounded-xl p-5">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold">
                Liked Photos ({selectedUser.likedPhotos.length})
              </h3>

              <button
                onClick={() => setSelectedUser(null)}
                className="text-red-500 text-lg"
              >
                ✕
              </button>
            </div>

       <div className="grid grid-cols-3 gap-3 max-h-[80vh] overflow-y-auto">
  {selectedUser?.likedPhotos.map((photo, index) => (
    <div
      key={index}
      className="border rounded-lg p-2 bg-gray-50"
    >
      <img
        src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${photo.url}`}
        alt="thumbnail"
        className="w-full aspect-square object-cover rounded-lg"
        loading="lazy"
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />

      <div className="mt-2 text-xs text-center text-gray-500 truncate">
        {photo.title}
      </div>
    </div>
  ))}
</div>
          </div>
        </div>
      )}
</div>
  );
}

export default PhotoAnalytics;